// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"041ab3dd","621":"423a17c6","743":"8412ba0f"}[chunkId] + ".chunk.js";
};